"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    default: ()=>TravelerSelection_TravelerSelectionMobile
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
const index_cjs_namespaceObject = require("../../Drawer/index.cjs");
const external_InputButton_index_cjs_namespaceObject = require("../../InputButton/index.cjs");
const external_OverlaySearchHeader_index_cjs_namespaceObject = require("../../OverlaySearchHeader/index.cjs");
const external_StickyActionBar_index_cjs_namespaceObject = require("../../StickyActionBar/index.cjs");
const TravelerSelectionContent_cjs_namespaceObject = require("../TravelerSelectionContent/TravelerSelectionContent.cjs");
function TravelerSelectionMobile({ ageSelectEnabled, disclaimer, isOpen, handleClose, isHotel, lapInfantLabel, maxAdults, maxChildren, maxRooms, fireMaxRoomsOnClick, maxRoomsMessage, maxRoomsUrl, roomsEnabled, shouldCountLapInfant, state, subLabelMap, handleOpen, isDisabled }) {
    const Footer = (0, external_react_namespaceObject.useCallback)(()=>{
        const handleDoneClick = ()=>{
            state.triggerValidation?.();
            handleClose();
        };
        return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
            children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_StickyActionBar_index_cjs_namespaceObject.StickyActionBar, {
                type: "primary",
                actionText: "Done",
                onClick: handleDoneClick,
                barType: "actionBar"
            })
        });
    }, [
        handleClose,
        state
    ]);
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
        className: "flex w-full flex-row",
        children: [
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_InputButton_index_cjs_namespaceObject.InputButton, {
                "data-testid": "traveler-selection-input-mobile",
                iconLeft: 'person',
                label: "Travelers",
                value: state.label,
                size: 'lg',
                onClick: handleOpen,
                className: "w-full",
                isDisabled: isDisabled,
                errorMessage: state.errorMessage
            }),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_cjs_namespaceObject.Drawer, {
                title: "Travelers",
                description: "Add your travelers",
                direction: "bottom",
                showCloseButton: false,
                showDragHandle: false,
                open: isOpen,
                scroll: "body",
                footer: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(Footer, {}),
                headingCustomNode: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_OverlaySearchHeader_index_cjs_namespaceObject.OverlayTitle, {
                    heading: "Travelers",
                    subHeading: state.label,
                    handleClose: handleClose
                }),
                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                    className: "relative flex w-full px-4 pt-2",
                    children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(TravelerSelectionContent_cjs_namespaceObject.TravelerSelectionContent, {
                        ageSelectEnabled: ageSelectEnabled,
                        disclaimer: disclaimer,
                        isHotel: isHotel,
                        lapInfantLabel: lapInfantLabel,
                        maxAdults: maxAdults,
                        maxChildren: maxChildren,
                        maxRooms: maxRooms,
                        maxRoomsMessage: maxRoomsMessage,
                        maxRoomsUrl: maxRoomsUrl,
                        roomsEnabled: roomsEnabled,
                        shouldCountLapInfant: shouldCountLapInfant,
                        state: state,
                        subLabelMap: subLabelMap,
                        fireMaxRoomsOnClick: fireMaxRoomsOnClick
                    })
                })
            })
        ]
    });
}
const TravelerSelection_TravelerSelectionMobile = /*#__PURE__*/ (0, external_react_namespaceObject.memo)(TravelerSelectionMobile);
exports["default"] = __webpack_exports__["default"];
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "default"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
